@if (arbetsorder) {
  <div>
    <div class="modal-header">
      <rask-header size="2">
        {{ arbetsorder.beteckning }} {{ arbetsorder.namn }}
      </rask-header>
      <div class="modal-header-actions">
        @if (showSelected) {
          <rask-checkbox
            text="Markera som vald i lista"
            (checkedChange)="onSelectedChanged($event)"
            class="checkbox"
            [(ngModel)]="isSelected">
          </rask-checkbox>
        }
      </div>
      <button type="button" class="btn-close close-x" aria-label="Close" (click)="close()">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <rask-container-block>
      @if ((messageItemsAsObservable | async).length > 0) {
        <div>
          <rask-message-panel
            [numberOfItemsToDisplay]="5"
            [maxNumOfRows]="2"
            [labels]="messageLabels"
            [items]="messageItemsAsObservable"
            (anchorClick)="handleMessagePanelClick($event)">
          </rask-message-panel>
        </div>
      }
      <div class="row">
        <div class="col-md-3 col-lg-2">
          @if (arbetsorder.typ !== 'Grotskotning') {
            <label for="relAo" class="col-form-label"
            translate>TPL_AODETAILS_RELATERAD_GROT_ARBETSORDER</label>
          }
          @if (arbetsorder.typ === 'Grotskotning') {
            <label for="relAo" class="col-form-label"
            translate>TPL_AODETAILS_RELATERAD_RV_ARBETSORDER</label>
          }
          <div class="controls">
            @if (arbetsorder.relateradArbetsorder === null) {
              <span id="relAo" class="form-control-static"
              >-</span>
            }
            @if (arbetsorder.relateradArbetsorder !== null) {
              <span id="relAo" class="form-control-static">
                <a href="/"
                  (click)="getArbetsorder($event, arbetsorder.relateradArbetsorder.id)">{{
                arbetsorder.relateradArbetsorder.beteckning }}</a>
              </span>
            }
          </div>
        </div>
        <div class="col-md-2 col-lg-1">
          <label for="skog" class="col-form-label" translate>TPL_AODETAILS_TILLGANGLIGHET_SKOG</label>
          <div class="controls">
            <span id="skog" class="form-control-static">{{ arbetsorder.tillganglighetSkog }}</span>
          </div>
        </div>
        <div class="col-md-2 col-lg-1">
          <label for="vag" class="col-form-label" translate>TPL_AODETAILS_TILLGANGLIGHET_VAG</label>
          <div class="controls">
            <span id="vag" class="form-control-static">{{ arbetsorder.tillganglighetVag }}</span>
          </div>
        </div>
        <div class="col-md-3 col-lg-2">
          <label for="skorningsstatus" class="col-form-label" translate>TPL_AODETAILS_SKORDNINGSSTATUS</label>
          <div class="controls">
            <span id="skorningsstatus" class="form-control-static">{{ arbetsorder.skordningsstatus }}</span>
          </div>
        </div>
        <div class="col-md-3 col-lg-2">
          <label for="skotningsstatus" class="col-form-label" translate>TPL_AODETAILS_SKOTNINGSSTATUS</label>
          <div class="controls">
            <span id="skotningsstatus" class="form-control-static">{{ arbetsorder.skotningsstatus }}</span>
          </div>
        </div>
        <div class="col-md-3 col-lg-2">
          <label for="transportstatus" class="col-form-label" translate>TPL_AODETAILS_TRANSPORTSTATUS</label>
          <div class="controls">
            <span id="transportstatus" class="form-control-static">{{ arbetsorder.transportstatus }}</span>
          </div>
        </div>
        <div class="col-md-3 col-lg-2">
          <label for="leverantor" class="col-form-label" translate>TPL_AODETAILS_LEVERANTOR</label>
          <div class="controls">
            <span id="leverantor" class="form-control-static">{{ arbetsorder.leverantor }}</span>
          </div>
        </div>
        <div class="col-md-3 col-lg-2">
          <label for="virkeskopare" class="col-form-label" translate>TPL_AODETAILS_VIRKESKOPARE</label>
          <div class="controls">
            <span id="virkeskopare" class="form-control-static">{{ arbetsorder.virkeskopare }}</span>
          </div>
        </div>
        @if (!arbetsorder.viol3) {
          <div class="col-md-3 col-lg-2">
            <label for="vostatus" class="col-form-label" translate>TPL_AODETAILS_VO_STATUS</label>
            <rask-virkesorderstatus-indicator
              [virkesorderstatus]="arbetsorder.voStatus"
              [isRaskVo]="arbetsorder.raskVo">
            </rask-virkesorderstatus-indicator>
          </div>
        }
        @if (arbetsorder.viol3) {
          <div class="col-md-3 col-lg-2">
            <label for="viol3status" class="col-form-label" translate>TPL_AODETAILS_VIOL3_STATUS</label>
            <rask-viol3status-indicator
              [arbetsorderid]="arbetsorder.id">
            </rask-viol3status-indicator>
          </div>
        }
        <div class="col-md-6 col-lg-5">
          <label for="maskinlag" class="col-form-label" translate>TPL_AODETAILS_MASKINLAG</label>
          <div class="controls">
            <span id="maskinlag" class="form-control-static">{{arbetsorder.maskinlag}}</span>
          </div>
        </div>
      </div>
      <rask-tpl-arbetsorder-list
        [arbetsorder]="arbetsorder"
        [content]="listContent">
      </rask-tpl-arbetsorder-list>
    </rask-container-block>
    <ng-container footer>
      <rask-button
        class="footer-button float-start"
        color="tertiary"
        [disabled]="!canEdit() || busyUpdating || !canDestinera()"
        icon="fas fa-sync-alt"
        (click)="uppdateraVirkesordrar()">
        Uppdatera från regelverk
        @if (busyUpdating) {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
      </rask-button>
      <rask-button
        class="footer-button float-start"
        color="tertiary"
        [disabled]="!canEdit() || busyUpdating || !canDestinera()"
        icon="fas fa-sync-alt"
        (click)="uppdateraDestineringsalternativ()">
        {{ 'TPL_DESTINERA_UPPDATERA_DESTINERINGSALTERNATIV' | translate }}
        @if (busyUpdating) {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
      </rask-button>
      <rask-button
        class="footer-button float-start"
        color="tertiary"
        [disabled]="!canEdit() || busyUpdating || !canDestinera()"
        icon="fas fa-plus"
        (click)="addManuellaDestineringsalternativ()">
        Lägg till destineringsalternativ
        @if (busyUpdating) {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
      </rask-button>
      <rask-button class="footer-button"
        color="primary"
        icon="far fa-up-right-from-square">
        <a [routerLink]="['/planera', arbetsorder.id]" target="_blank">Till produktionsplanering (ny flik)</a>
      </rask-button>
    </ng-container>
  </div>
}
